import { render, staticRenderFns } from "./studentLessonList.vue?vue&type=template&id=b65ec0b2&scoped=true&"
import script from "./studentLessonList.vue?vue&type=script&lang=js&"
export * from "./studentLessonList.vue?vue&type=script&lang=js&"
import style0 from "./studentLessonList.vue?vue&type=style&index=0&id=b65ec0b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65ec0b2",
  null
  
)

export default component.exports